import React,{useEffect,useState} from 'react';
import {appGetUrlPath,btnSetColor_CBack} from '../function_lib/common_lib';
import user_default from '../assets/images/user_icon.png';
import {FileUploaderV1} from '../function_lib/upload_lib_file';
import './comp_popeup_profile_viewer.css'

const Comp_Process_Form=(props)=>{
  let appUrlMedPath=appGetUrlPath();
  return   <div class="d-flex flex-column flex-md-row">
  <div class="modal-image-section col-md-12">
    <div class="profile-image-container">
      
      <div class="verified-tickmark">Verified</div>
    </div>
    <div class="basic-details">
      <p><strong>Request Id:</strong> {props.profileData?.id}</p>
      <p><strong>Request Date:</strong> {props.profileData?.request_date}</p>
      
    
    </div>
    <form class="digital-seva-point-new-form" id="frmProcessForm" name="frmProcessForm">
          <input type='hidden' name="m_type" id="m_type" value={"doProcessForm"} />
                 <input type='hidden' name="m_type" id="m_type" value={"doProcessForm"} />
                 <input type='hidden' name="res_func" id="res_func" value={"resnuse"}/>
                 <input type='hidden' name="loc_token" id="loc_token" value={props.compUser[0].id}/>
                 <input type='hidden' name="ref_request_id" id="ref_request_id"  value={btoa(props.profileData?.id)}/>
                 <input type='hidden' name="lsProcFiles" id="lsProcFiles"/>
                 {/* <input type="hidden" name="ref_form_category" id="ref_form_category" value={btoa(props.formFields[0]["category_master_id"])} /> */}
            
          <div class="row">

          <div className="col-md-12 col-lg-6">
                         <div className="billing-select mb-4">
                            <label  class="flabel">Acknowledgment No.</label>
                            <input className="form-control f-input required" id={"ack_no"} name={"ack_no"} type="text"
                            defaultValue={props.profileData?.ack_no}
                            />
                         </div>
                     </div>

                     <div className="col-lg-6">
                         <div className="billing-select mb-4">
                             <label  class="flabel">Process Status</label>
                             <select className="form-control f-select select_target f-select required" id={"process_status"} name={"process_status"}>
                                 <option selected={props.profileData?.process_status===""} value={""}>Select</option>
                                 <option selected={props.profileData?.process_status==="Completed"} value={"Completed"}>Completed</option>
                                 <option selected={props.profileData?.process_status==="Under Process"} value={"Under Process"}>Under Process</option>
                                 <option selected={props.profileData?.process_status==="Under Progress"} value={"Under Progress"}>Under Progress</option>
                                 <option selected={props.profileData?.process_status==="Under Review"} value={"Under Review"}>Under Review</option>
                                 <option selected={props.profileData?.process_status==="Rejected"} value={"Rejected"}>Rejected</option>
                                 <option selected={props.profileData?.process_status==="Canceled"} value={"Cancelled"}>Cancelled</option>
                               
                             </select>
                         </div>
                     </div>

                     <div className="col-lg-12 col-md-12">
                      {props.profileData?.doc_release!==""?<a target='blank' href={appUrlMedPath+props.profileData?.doc_release}>View Uploded File</a>:''} 
                            <div className="billing-info mb-4">
                                {/* <label  class="flabel">{"Acknowledgement Receipt"}</label> */}
                                <input type="file" name={"upd_acknow_rec"} id={"upd_acknow_rec"} ref_img="ImageThumbBackNew" thumbnail_div={"oth_img_div"} lsElement={"lsProcFiles"} thumbnail={"imgLibThumb_processFmr"} accept="image/*" capture="camera" size={1000000000} 
          className='updImgThumb'
          />
                                <button class="file-zone _brFileThumb updthumb"   onClick={(e) => {
e.preventDefault();
e.stopPropagation();
}} setTo={"upd_acknow_rec"}>
         
          <div class="file-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="17 8 12 3 7 8"/>
              <line x1="12" y1="3" x2="12" y2="15"/>
            </svg>
          </div>
          <div class="file-text">
            <div class="ft-main">Acknowledgement Receipt</div>
            <div class="ft-sub">PDF, JPG, PNG up to 5MB</div>
          </div>
        </button>

                               
                                
                            </div>
                            <div class={"row upload_image_css "+ "imgLibThumb_processFmr"}></div>
                        </div>

          <div className="col-lg-12">
                         <div className="billing-select mb-4">
                             <label  class="flabel">Description (if Any)</label>
                            <textarea defaultValue={props.profileData?.process_desc} class="form-control" id="process_desc" name="process_desc">

                            </textarea>
                         </div>
                     </div>

                     <div class="submit-strip">
{/* <button type="button" onClick={()=>doProcessForm()}  class="btn-submit _btnSetColor11">Submit Process</button> */}
<button type="reset" class="btn-reset">Reset</button>
</div>
         
          </div>
          </form>
  </div>

 
  {/* <div class="gallery-container col-md-7">
          <div class="gallery-title"><h5>Process Form</h5></div>
          
        </div> */}
</div>
}
const Comp_Popup_Profile_Viewer=(props)=>{
  let appUrlMedPath=appGetUrlPath();
  const [getViewContacts,setViewContacts]=useState(0);

  //uncomment when retailer have to start process Form
  // const doProcessForm=()=>{
  //   //alert("i min click");
  //     btnSetColor_CBack(this,"frmProcessForm","doProcessForm",function(data,msg){
  //       if(data==="001"){
  //         alert(msg);
  //         window.location.reload();
  //       }else{
  //         alert(msg);
  //       }
  //     })
  // }

  //let getViewContacts=0;
   useEffect(()=>{
      if(typeof props.profileData.req_status!=="undefined"){
        if(props.profileData.req_status==="Accepted"){
          setViewContacts(1);
          //getViewContacts=1;
        }else{
          setViewContacts(0);
        }
      }else{
        setViewContacts(0);
      }
      //alert(JSON.stringify(props.profileData));
      FileUploaderV1(this,function(data,msg){
        //alert("i m done");
       });
   },[props.profileData,getViewContacts])
    return(
      <div class="modal fade popup_profile_viewer_khandelwal_parinay" id="profileModal" tabindex="-1" aria-labelledby="profileModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-lg-custom text-start">
          {typeof props.profileData.form_request!=="undefined"?
          <div class="modal-content">
            <button type="button" class="close-btn" data-bs-dismiss="modal" aria-label="Close">
              &times;
            </button>

            <div class="modal-body p-0">
            
              
              <div class="d-flex flex-column flex-md-row">
              <div class="text-section w-100 w-md-35">
                  <h3 class="section-title">Personal Details</h3>
                  {JSON.parse(props.profileData?.form_request || "[]").map((member, memberIndex) => (

<div key={memberIndex} className="mb-3 p-2 border11">

  <h6>Member {memberIndex + 1}</h6>

  {member.map((formItem, formIndex) => {

    if (formItem.field_type === "text" || formItem.field_type === "dropdown") {
      return (
        <p key={formIndex}>
          <strong>{formItem.field_name}:</strong> {formItem.value}
        </p>
      );
    }

    else if (formItem.field_type === "file" && formItem.value) {

      const file = formItem.value.toLowerCase();

      if (
        file.includes(".jpg") ||
        file.includes(".jpeg") ||
        file.includes(".png") ||
        file.includes(".webp")
      ) {
        return (
          <p key={formIndex}>
            <strong>{formItem.field_name}:</strong><br />
            <img
              className="gallery-image"
              src={appUrlMedPath + formItem.value}
              alt="preview"
              style={{ maxWidth: "150px" }}
            />
            <a href={appUrlMedPath + formItem.value} download target="_blank">Download File</a>
          </p>
        );
      }

      // fallback for non-image files
      return (
        <p key={formIndex}>
          <strong>{formItem.field_name}:</strong>{" "}
          <a href={appUrlMedPath + formItem.value} target="_blank">
            View File
          </a>
        </p>
      );
    }

    return null;

  })}

</div>

))}
                 
                 
                </div>
                
               
              
               
              </div>
            </div>
          </div>:''}
        </div>
      </div>
//  </div>
    );
}
export default Comp_Popup_Profile_Viewer;
